export default __webpack_public_path__ + "static/media/mar.c057db03.jpg";